import { useMutation } from 'react-query';

import { deleteCardAssociatedDocument as mutationFn } from 'api/endPoints/deleteCardAssociatedDocument';

export const useMutationDeleteExternalDocument = () => {
    return useMutation<string, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

interface QueryParams {
    id: number;
}
